import { CheckCircle2, X } from "lucide-react";
import { useEffect } from "react";

interface LoginSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    userName: string;
}

export default function LoginSuccessModal({
    isOpen,
    onClose,
    userName
}: LoginSuccessModalProps) {

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            const timer = setTimeout(onClose, 2000); // Fecha automaticamente após 2s
            return () => {
                clearTimeout(timer);
                document.body.style.overflow = 'unset';
            };
        }
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

            <div className="relative bg-card border border-border/50 shadow-2xl rounded-2xl p-8 max-w-md w-full mx-4 animate-in fade-in zoom-in-95 duration-300">
                <button onClick={onClose} className="absolute right-4 top-4 p-2 hover:bg-muted rounded-full transition-colors">
                    <X className="w-4 h-4" />
                </button>

                <div className="text-center">
                    <div className="mb-6">
                        <div className="w-16 h-16 mx-auto bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center shadow-lg">
                            <CheckCircle2 className="w-8 h-8 text-white" />
                        </div>
                    </div>

                    <h2 className="text-2xl font-bold mb-4">
                        <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                            Bem-vindo de volta!
                        </span>
                    </h2>

                    <p className="text-muted-foreground mb-8 leading-relaxed">
                        Olá, <strong>{userName}</strong>! Login realizado com sucesso.
                    </p>
                </div>
            </div>
        </div>
    );
}